import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "guide-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoLabelControl = _resolveComponent("HakoLabelControl")!
  const _component_HakoMultiselect = _resolveComponent("HakoMultiselect")!
  const _component_HakoSwitch = _resolveComponent("HakoSwitch")!
  const _component_HakoButton = _resolveComponent("HakoButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.chosenguideprop)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1, "Ohjetta ei julkaista vielä tässä vaiheessa."))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HakoLabelControl, {
        for: "guidename",
        label: "Nimi"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HakoInput, {
            modelValue: _ctx.guide.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.guide.name) = $event)),
            name: "guidename"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_HakoLabelControl, {
        for: "categoryselect",
        label: "Kategoria"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.guide.category?.text), 1),
          _createVNode(_component_HakoMultiselect, {
            "disallow-remove": true,
            "use-avatar": false,
            modelValue: _ctx.guide.category.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.guide.category.value) = $event)),
            options: _ctx.categories
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_HakoLabelControl, {
        for: "order",
        label: "Järjestysnumero"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HakoInput, {
            type: "number",
            modelValue: _ctx.guide.order,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.guide.order) = $event)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_HakoLabelControl, {
        for: "publishstatus",
        label: "Julkaistu"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HakoSwitch, {
            modelValue: _ctx.guide.published,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.guide.published) = $event)),
            name: "publishstatus"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (_ctx.guide.id)
        ? (_openBlock(), _createBlock(_component_HakoButton, {
            key: 0,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveGuide())),
            class: "btn-primary",
            "is-block": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tallenna")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_HakoButton, {
            key: 1,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveGuide())),
            class: "btn-success",
            "is-block": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Lisää ohje")
            ]),
            _: 1
          }))
    ])
  ]))
}